/**
 * Method names for handlers
 */
export class hubMethods {
  static maintenanceOperatorStarted = 'OperatorMaintenanceStarted';
  static maintenanceEventStarted = 'EventMaintenanceStarted';
  static reloadRequired = 'ReloadRequired';
}

/**
 * Method names for invocations.
 */
export class hubSignals {
  // place method names for connection.invoke() HERE
}
